import '@/css/desktop/layout.scss';
import './error404.css';
import '@/js/common/Domain/Service/tracking/trackingUserVisit';
import '@/js/common/Domain/Service/tracking/trackingCoreWebVitals';

$(() => {
    window.dataLayer.push({ event: 'page404' });
});